import { apiClient, fastApiClient } from "../App";

export const getMedia = (mediaType, search = "") =>
  fastApiClient.get("/tool_media", {
    params: {
      media_type: mediaType || undefined,
      search: search || undefined,
    },
  });

export const createMedia = (formData) =>
  fastApiClient.post("/tool_media", formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });

export const deleteMedia = (id) => fastApiClient.delete(`/tool_media/${id}`);